import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { Description } from "@material-ui/icons";

import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { useSearch } from "hooks/useSearch";
import { monthsDictionary } from "helpers/dictionary";

import {
  getRetentions,
  setWholesalerRetentionsFilters,
} from "redux/actions/wholesalerRetentions/wholesalerRetentionsActions";
import { columns } from "./columns";
import { WHOLESALER_RETENTIONS_LABELS } from "./labels";
import { retentionsSelector } from "./retentionsSelector";

const { title, messages } = WHOLESALER_RETENTIONS_LABELS;

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

export default function WholesalerRetentionsView() {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { station, month, year } = useSelector((s) => s.wholesalerRetentions);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const retentions = useSelector(retentionsSelector);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!station?.id) return setSnackbar(messages.selectStation, "warning");
    dispatch(getRetentions({station, month, year}));
  };

  const handleMonthChange = (_, value) => {
    dispatch(setWholesalerRetentionsFilters("month", value?.value || null));
  };

  const handleYearChange = (_, value) => {
    dispatch(setWholesalerRetentionsFilters("year", value));
  };

  const selectedMonth = monthsDictionary.find((m) => m.value === month) || null;

  return (
    <CardTable
      data={retentions}
      columns={columns()}
      hasHeader
      blockBtn
      title={title}
      icon={<Description />}
      isLoading={isLoadingComp?.loadingRetentions}
      tableContent={
        <TableInputs
          stations
          reducer="wholesalerRetentions"
          dispatchAction={setWholesalerRetentionsFilters}
          submitAction={handleSubmit}
          loading={isLoadingComp?.loadingRetentions}
        >
          <Grid item xs={12} sm={2}>
            <Autocomplete
              options={monthsDictionary}
              getOptionLabel={(option) => option.label}
              value={selectedMonth}
              onChange={handleMonthChange}
              renderInput={(params) => (
                <TextField {...params} label="Mes" variant="outlined" size="small" />
              )}
              noOptionsText="Sin opciones"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              options={yearOptions}
              getOptionLabel={(option) => String(option)}
              value={year}
              onChange={handleYearChange}
              disableClearable
              renderInput={(params) => (
                <TextField {...params} label="Año" variant="outlined" size="small" />
              )}
              noOptionsText="Sin opciones"
            />
          </Grid>
        </TableInputs>
      }
    />
  );
}
